export const FormTypes = {
  "ADD_VALIDATION_FIELD": "ADD_VALIDATION_FIELD",
  "REMOVE_VALIDATION_FIELD": "REMOVE_VALIDATION_FIELD",
  "ADD_DEPENDENT_FIELDS": "ADD_DEPENDENT_FIELDS",
  "REMOVE_DEPENDENT_FIELDS": "REMOVE_DEPENDENT_FIELDS",
  "ADD_PREVENT_FORM_SUBMISSION_FIELD": "ADD_PREVENT_FORM_SUBMISSION_FIELD",
  "REMOVE_PREVENT_FORM_SUBMISSION_FIELD": "REMOVE_PREVENT_FORM_SUBMISSION_FIELD"
};